<div class="person-detail-wrapper">
	<div class="person-detail">
		<img class="person-detail__image" width="800" height="540" :src="`${person.imageUrl}?width=800&height=540`" />

		<h3 class="title mt-0 person-detail__name">{{person.firstname}} {{person.lastname}}</h3>

		<div class="person-detail__info person-detail__functions content mb-0" v-if="person.functions != null && person.functions.length > 0">
			<h3 class="title has-text-weight-normal">Funktionen</h3>
			<!-- The teacher function is derived from the subjects; here they are linked instead of repeating its text. -->
			<ul class="is-flush">
				<li v-for="func in person.functions">
					<template v-if="isTeacherFunction(func)">
						{{func.roleDisplayName}}
						<template v-for="(subject, index) in person.subjects"><template v-if="index > 0">, </template><a :href="subject.url">{{subject.title}}</a></template>
					</template>
					<template v-else>{{func.description}}</template>
				</li>
			</ul>
		</div>

		<div class="person-detail__info person-detail__contacts content mb-0" v-if="person.contacts != null && person.contacts.length > 0">
			<h3 class="title has-text-weight-normal">Kontakt</h3>
			<dl class="person-detail__contacts-list">
				<template v-for="contact in person.contacts">
					<dt class="contact-label">{{contactTypeNames.get(contact.type)}}</dt>
					<dd>
						<a :href="formatContactLink(contact)" target="_blank">{{contact.value}}</a>
					</dd>
				</template>
			</dl>
		</div>
	</div>
</div>
